import { menu } from 'resolutions/all/menu'

function load (filename) {
  if (!filename) return

  import(/*  webpackMode: "eager", webpackChunkName: "submenu-desktop" */ 'html/desktop/mainmenu/' + `${filename}.js`)
    .then(submenuContent => {
      submenuContent = submenuContent.default
      console.log(`DEBUG (resolutions.desktop.loadSubMenu) Loaded submenu for ${menu.active}:`, { menu, filename })

      if (menu.submenu && submenuContent && menu.active) {
        menu.submenu.setAttribute('data-menuroot', menu.active)
        Object.assign(menu.submenu, {
          innerHTML: submenuContent,
          className: 'visible'
        })
      }
    })
    .catch(error => {
      console.log(`!!! ERROR (resolutions.desktop.loadSubMenu): Error!  Unable to load submenu for ${menu.active}.`, menu)
      console.log(error)
      console.log(`Filename: ${filename}`)
      MK.capturePromiseRejection(error)
    })
}

export const loadSubMenu = (event = {}) => {
  console.log('loadSubMenu', event)
  if (MK.active.resolution !== 'desktop') return

  try {
    console.log('Desktop Menu', menu)

    menu.active = event && event.target && event.target.getAttribute('data-menuroot')
    MK.active.submenu = menu.active

    console.log(`DEBUG (resolutions.desktop.loadSubMenu) Attempting to load submenu for ${menu.active}:`, { menu, event })

    if (!menu.active) return
    let filename = `${menu.active}`.replace(/-|\s/g, '').toLowerCase()
    load(filename)
  } catch (error) {
    console.log(`!!! ERROR (resolutions.desktop.loadSubMenu): Error!  Unable to load submenu for ${menu.active}.`, menu, event)
    console.log(menu)
    console.log(event)
    console.log(error)
    MK.captureException(error)
  }
}
